module.exports = __webpack_public_path__ + "static/media/05_D.b522c99c.png";